import React from "react";
import { Link, useLocation } from "react-router-dom";

const DropDown = ({ list = [], onClick = () => {}, keyItem = "" }) => {
  const location = useLocation();
  return (
    <div className="rounded bg-white shadow-common flex flex-col overflow-clip absolute w-[250px] top-full translate-y-5">
      {list.map((obj, index) => {
        const notLastItem = index !== list.length - 1;
        const isActive = location.pathname === obj.url;
        const isDisabled = !obj.url;

        const baseClass = `p-3 font-medium text-sm !leading-100 ${
          notLastItem ? "border-b border-custom-black border-opacity-10" : ""
        }`;

        if (isDisabled) {
          return (
            <span
              key={index}
              className={`${baseClass} text-gray-400 pointer-events-none bg-opacity-50`}
            >
              {obj.title}
            </span>
          );
        }

        return (
          <Link
            onClick={onClick}
            to={obj.url}
            key={index}
            className={`${baseClass} hover:bg-custom-black/30 hover:text-custom-white-v2 ${
              isActive ? "bg-custom-black/10" : ""
            }`}
          >
            {obj.title}
          </Link>
        );
      })}
    </div>
  );
};

export default DropDown;
